import React, { useEffect, useState } from 'react';
import { useTelemedicina } from 'context/TelemedicinaContext';
import useModelHorarios from './useModelHorarios';
import {
  Box,
  Button,
  Flex,
  Grid,
  Heading,
  HStack,
  Icon,
  Image,
  Skeleton,
  SkeletonCircle,
  chakra,
  Text,
  VStack,
  Spinner,
  Avatar,
} from '@chakra-ui/react';
import BackButton from '../../../../../../images/assets/telemedicina/backbutton.svg';
import { ArrowForwardIcon, StarIcon } from '@chakra-ui/icons';

function Horarios() {
  const { medicoSelecionado, loading, navigate, agendas, setAgendamento } = useModelHorarios();
  const [imgLoaded, setImgLoaded] = React.useState(false);
  const isLoading = loading;
  const [localLoading, setLocalLoading] = React.useState(false);

  useEffect(() => {
    setLocalLoading(true);
    const timer = setTimeout(() => setLocalLoading(false), 900);
    return () => clearTimeout(timer);
  }, [medicoSelecionado]);

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';

    const primeiroNome = capitalizar(partes[0]);

    if (partes.length === 1) return primeiroNome;

    const segundoNome = capitalizar(partes[1]);

    return `${primeiroNome} ${segundoNome}`;
  };

  const DateButton = ({ dayOfWeek, date, fullDate, isSelected, onClick }) => (
    <Button
      width="100%"
      height="100%"
      minHeight="40px"
      variant="solid"
      borderRadius="xl"
      boxSizing="border-box"
      p={4}
      onClick={() => onClick(fullDate)}
      bg={'white'}
      color={isSelected ? 'white' : 'gray.800'}
      borderColor={isSelected ? '#1CBBB4' : '#e0f7fa'}
      borderWidth="1px"
      _hover={{ bg: isSelected ? '#15a09b' : '#eaf4ff' }}
      _active={{ bg: isSelected ? '#15a09b' : '#dff0ff' }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text fontSize="sm" fontWeight="bold" color={'#616161'} mb={1}>
        {dayOfWeek}
      </Text>
      <Text fontSize="sm" fontWeight="bold" color={'#5AB2AE'} bg={'#E1F1F1'} px={2} py={1} borderRadius="md">
        {date}
      </Text>
    </Button>
  );

  const agendasSafe = Array.isArray(agendas) ? agendas : [];
  const toISODate = (dateStr) => {
    if (/^(\d{2})\/(\d{2})\/(\d{4})$/.test(dateStr)) {
      const [dia, mes, ano] = dateStr.split('/');
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    }
    if (/^(\d{4})-(\d{2})-(\d{2})$/.test(dateStr)) {
      return dateStr;
    }
    return dateStr;
  };
  const agendasByDate = agendasSafe.reduce((acc, item) => {
    const isoDate = toISODate(item.AVA_DATE);
    if (!acc[isoDate]) acc[isoDate] = [];
    acc[isoDate].push(item);
    return acc;
  }, {});
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const availableDates = Object.keys(agendasByDate)
    .map((isoDateStr) => {
      const [ano, mes, dia] = isoDateStr.split('-');
      const dateObj = new Date(Number(ano), Number(mes) - 1, Number(dia));
      if (isNaN(dateObj.getTime())) return null;
      const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
      return {
        dayOfWeek: dayNames[dateObj.getDay()],
        date: `${dia}/${mes}`,
        fullDate: isoDateStr,
      };
    })
    .filter(Boolean);

  const [selectedDate, setSelectedDate] = useState(null);
  const [showHorarios, setShowHorarios] = useState(false);
  const [selectedHorario, setSelectedHorario] = useState(null);

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const formatarAvaliacao = (media) => {
      const valor = Math.floor(media * 10) / 10;
      return valor.toFixed(1);
    };

    useEffect(() => {
      if (avaliacao) {
        const media =
          !avaliacao.avaliacao_media || avaliacao.avaliacao_media === '0' ? 5 : avaliacao.avaliacao_media >= 1 ? avaliacao.avaliacao_media : 5;

        setAvaliacaoMedia(formatarAvaliacao(media));
        setIsLoading(false);
      }
    }, [avaliacao]);

    return (
      <chakra.span mt={-0.5}>
        <StarIcon color="orange" fontSize="1em" mt={-0.3} />
        <chakra.span fontSize="0.625em" color="orange" fontWeight={600}>
          {isLoading ? <Spinner size="sm" color="#5ab2ae" /> : avaliacaoMedia}
        </chakra.span>
      </chakra.span>
    );
  };

  let titulo = '';
  if (medicoSelecionado?.medico?.sexo === 'M') {
    titulo = 'Dr. ';
  } else if (medicoSelecionado?.medico?.sexo === 'F') {
    titulo = 'Dra. ';
  }
  function capitalize(text) {
    if (!text || typeof text !== 'string') return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  const especialidadeFiltrada =  medicoSelecionado?.medico?.especialidades && medicoSelecionado?.medico?.especialidades.length > 0 ? 
            medicoSelecionado?.medico?.especialidades.filter(e=>Number(e.id) === Number(medicoSelecionado?.especialidadeId)).map(e=>capitalize(e.especialidade)).join(', ') : null;
  const especialidadeMedico = medicoSelecionado?.medico?.especialidades && medicoSelecionado?.medico?.especialidades.length > 0 ? 
            medicoSelecionado?.medico?.especialidades.map(e=>capitalize(e.especialidade)).join(', ') : null;
  const especialidade = especialidadeFiltrada ? especialidadeFiltrada : especialidadeMedico;
  return (
    <>
      <VStack bg="#5AB2AE" minH="100vh" w="100vw" spacing={0}>
        <Box
          p={3}
          w={{ base: '98%', sm: '96%' }}
          maxW="480px"
          position="fixed"
          top={6}
          left="50%"
          transform="translateX(-50%)"
          zIndex={10}
          mt={6}
        >
          <Flex align="center" justify="center" w="100%" position="relative">
            <Box position="absolute" left={2} top="50%" transform="translateY(-50%)">
              <Box
                onClick={() => navigate(-1)}
                cursor="pointer"
                p={3}
                borderRadius="full"
                bg="whiteAlpha.200"
                _hover={{ bg: 'whiteAlpha.300', transform: 'scale(1.05)' }}
                _active={{ bg: 'whiteAlpha.400', transform: 'scale(0.95)' }}
                transition="all 0.2s ease"
                display="flex"
                alignItems="center"
                justifyContent="center"
                minW="44px"
                minH="44px"
              >
                <SkeletonCircle isLoaded={imgLoaded} size={{ base: '28px', sm: '28px' }}>
                  <Image
                    src={BackButton}
                    boxSize={{ base: '28px', sm: '28px' }}
                    onLoad={() => setImgLoaded(true)}
                    filter="brightness(1.1)"
                  />
                </SkeletonCircle>
              </Box>
            </Box>
            <Box flex={1} display="flex" justifyContent="center" ml={4}>
              <Skeleton isLoaded={!isLoading} borderRadius="8px">
                <Text fontSize={{ base: '1em', sm: '1.3em' }} color="white" fontWeight="bold" textAlign="center">
                  Telemedicina Especialista
                </Text>
              </Skeleton>
            </Box>
          </Flex>
        </Box>
        <Flex w="100vw" minH="100vh" align="center" justify="center" pt={{ base: 3, sm: 6 }} direction="column">
          <Flex
            align="center"
            bg="#F4F7F7"
            borderRadius="2em"
            p={{ base: 2, sm: 3 }}
            mb={2}
            boxShadow="md"
            w={{ base: '96%', sm: '100%' }}
            maxW={{ base: '98vw', sm: '400px' }}
            flexWrap="wrap"
            mt={{ base: 16, sm: 20 }}
            onClick={() => {
              const medico = medicoSelecionado?.medico || medicoSelecionado?.medico;
              navigate('/empresa/medico/curriculo', { state: { medico: { dados: medico }, avaliacao: medicoSelecionado.avaliacao } });
            }}
          >

            <Avatar
              name={tratarNome(medicoSelecionado?.medico?.nome || medicoSelecionado?.medico?.nome) || 'Médico'}
              alt={tratarNome(medicoSelecionado?.medico?.nome || medicoSelecionado?.medico?.nome)}
              boxSize="56px"
              borderRadius="lg"
              mr={{ base: 0, sm: 4 }}
              mb={{ base: 3, sm: 0 }}
              src={process.env.REACT_APP_URL_PROFILEPICS_OPERADOR + '/' + medicoSelecionado?.medico?.medico_id + '/foto_profissional.png'}
              mt={2}
              fontSize="0.75rem"
              color="white"
              bg="#5AB2AE"
              onClick={() =>
                navigate('/empresa/medico/curriculo', {
                  state: { medico: { dados: medicoSelecionado?.medico }, avaliacao: medicoSelecionado.avaliacao },
                })
              }
            />

            <Box flex="1" minW={{ base: '120px', sm: '180px' }} pr={2}>
              <HStack w="100%" justify="space-between" align="center">
                <Text
                  fontWeight="bold"
                  fontSize={{ base: 'sm', sm: 'md' }}
                  color="#616161"
                  isTruncated
                  maxW={{ base: '200px', sm: '200px' }}
                  title={tratarNome(medicoSelecionado.medico?.nome || medicoSelecionado.medico?.nome)}
                >
                  {titulo} {tratarNome(medicoSelecionado.medico?.nome || medicoSelecionado.medico?.nome)}
                </Text>
                <AvaliacaoEstrela avaliacao={medicoSelecionado.avaliacao} />
              </HStack>
              <HStack w="100%" align="center" spacing={2}>
                <Text fontSize={{ base: 'xs', sm: 'sm' }} color="#4A4A4A" noOfLines={2} maxW={{ base: '180px', sm: '180px' }} wordBreak="break-word">
                  {
                    especialidade ? 
                    especialidade :
                    capitalize(medicoSelecionado.medico?.especialidade || medicoSelecionado.medico?.especialidade)
                  }
                </Text>

                <Text fontSize={{ base: 'xs', sm: 'sm' }} color="#9E9E9E" noOfLines={2} maxW={{ base: '200px', sm: '200px' }} wordBreak="break-word">
                  {medicoSelecionado.medico?.conselho && medicoSelecionado.medico?.conselho}{' '}
                  {medicoSelecionado.medico?.rqe && medicoSelecionado.medico?.rqe}
                </Text>
              </HStack>
            </Box>
          </Flex>
          <Box
            p={{ base: 3, sm: 8 }}
            borderWidth="1px"
            borderColor="#e0f0f0"
            borderRadius="2xl"
            bg="white"
            w={{ base: '96%', sm: '100%' }}
            maxW={{ base: '98vw', sm: '400px' }}
            minH={'600px'}
          >
            <VStack spacing={3} align="center" textAlign="center" mb={8} w="100%">
              <Heading as="h1" fontSize={{ base: 'md', sm: 'lg' }} fontWeight="600" color="#616161" lineHeight="1.3">
                Agendamento com Especialista
              </Heading>

              <Text fontSize={{ base: 'sm', sm: 'sm' }} color="#616161" maxW="320px">
                Abaixo você visualiza os horários disponíveis. Selecione uma para continuar.
              </Text>
            </VStack>

            {!showHorarios ? (
              <>
                <Grid
                  templateColumns={{ base: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' }}
                  gap={{ base: 2, sm: 3 }}
                  mb={8}
                  px={{ base: '2px', sm: 2 }}
                  py={{ base: 1, sm: 2 }}
                  overflowY={'auto'}
                  maxH={'none'}
                >
                  {localLoading || isLoading
                    ? Array.from({ length: 6 }).map((_, idx) => <Skeleton key={idx} height="70px" borderRadius="xl" />)
                    : availableDates.map((item) => {
                        return (
                          <DateButton
                            key={item.fullDate}
                            dayOfWeek={item.dayOfWeek}
                            date={item.date}
                            fullDate={item.fullDate}
                            isSelected={selectedDate === item.fullDate}
                            onClick={() => {
                              setSelectedDate(item.fullDate);
                              setShowHorarios(false);
                            }}
                          />
                        );
                      })}
                </Grid>
                <Flex w="100%" justify="flex-end" position="sticky" bottom={0} zIndex={10} bg="white" p={2}>
                  <Button
                    width="100%"
                    colorScheme="teal"
                    color="white"
                    rightIcon={<Icon as={ArrowForwardIcon} boxSize={{ base: 4, sm: 5 }} />}
                    _hover={{ bg: '#348e89' }}
                    borderRadius="1em"
                    fontSize={{ base: 'xs', sm: 'sm', md: 'sm' }}
                    py={{ base: 2, sm: 2, md: 3 }}
                    textAlign="center"
                    isDisabled={!selectedDate}
                    onClick={() => setShowHorarios(true)}
                  >
                    Continuar
                  </Button>
                </Flex>
              </>
            ) : (
              <Box>
                <Flex justify="space-between" align="center" mb={2}>
                  <Text fontSize="sm" color="#5AB2AE" fontWeight="bold">
                    Horários disponíveis:
                  </Text>
                  <Button size="xs" variant="ghost" colorScheme="teal" onClick={() => setShowHorarios(false)}>
                    Voltar
                  </Button>
                </Flex>
                {localLoading || isLoading ? (
                  <Grid templateColumns={{ base: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' }} gap={{ base: 1, sm: 2 }} mb={8}>
                    {Array.from({ length: 6 }).map((_, idx) => (
                      <Skeleton key={idx} height="48px" width="80px" borderRadius="xl" />
                    ))}
                  </Grid>
                ) : (
                  <Grid
                    maxH={'360px'}
                    overflowX={'auto'}
                    templateColumns={{ base: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' }}
                    gap={{ base: 1, sm: 2 }}
                    mb={8}
                    overflow={'auto'}
                  >
                    {(agendasByDate[selectedDate] || []).map((agenda) => (
                      <Box
                        key={agenda.AVAILABILITY_LID}
                        borderRadius="xl"
                        borderWidth="1px"
                        borderColor="#e0f7fa"
                        bg="white"
                        minH="48px"
                        minW="60px"
                        maxW="80px"
                        w={{ base: '70px', sm: '80px' }}
                        h={{ base: '48px', sm: '48px' }}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        boxShadow={selectedHorario === agenda.AVAILABILITY_LID ? '0 0 0 2px #1CBBB4' : 'none'}
                        transition="box-shadow 0.2s"
                      >
                        <DateButton
                          dayOfWeek={''}
                          date={agenda.AVA_START_TIME}
                          fullDate={agenda.AVAILABILITY_LID}
                          isSelected={selectedHorario === agenda.AVAILABILITY_LID}
                          onClick={() => {
                            setSelectedHorario(agenda.AVAILABILITY_LID);
                            setAgendamento((prevState) => ({
                              ...prevState,
                              data: selectedDate,
                              horario: agenda.AVA_START_TIME,
                              agenda_exames_id: agenda.AVAILABILITY_LID,
                            }));
                          }}
                          style={{ width: '100%', height: '100%', minHeight: '48px', minWidth: '60px', maxWidth: '80px' }}
                        />
                      </Box>
                    ))}
                  </Grid>
                )}
                <Flex w="100%" justify="flex-end" position="sticky" bottom={0} zIndex={10} bg="white" p={2}>
                  <Button
                    width="100%"
                    colorScheme="teal"
                    color="white"
                    rightIcon={<Icon as={ArrowForwardIcon} boxSize={{ base: 4, sm: 5 }} />}
                    _hover={{ bg: '#348e89' }}
                    borderRadius="1em"
                    fontSize={{ base: 'xs', sm: 'sm', md: 'sm' }}
                    py={{ base: 2, sm: 2, md: 3 }}
                    textAlign="center"
                    isDisabled={!selectedHorario || localLoading}
                    onClick={() => {
                      navigate('/confirmacao');
                    }}
                  >
                    Pronto!
                  </Button>
                </Flex>
              </Box>
            )}
          </Box>
        </Flex>
      </VStack>
    </>
  );
}

export default Horarios;
